import React from 'react';
import { Button, Col, Row, Spin } from 'antd';
import AddTariffForm from '../formSections/AddTariffForm';

class AddTariff extends React.Component {
  handleTariff = tariff => {
    const { tariffsPeriods, handleTariff, next } = this.props;
    let Tariff;
    tariffsPeriods.map(period =>
      Object.keys(period).map(key => {
        if (parseInt(key) === tariff) {
          Tariff = period[key];
        }
        return null;
      })
    );
    handleTariff({
      tariff_type_id: tariff,
      tariff_fee_period_id: Tariff.tariffFeePeriodId,
    });
    next();
  };
  render() {
    const { form, next, prev, tariffs, defaultPrices } = this.props;
    if (!tariffs) {
      return (
        <div style={{ textAlign: 'center' }}>
          Подождите, идет загрузка... <Spin />
        </div>
      );
    } else if (!tariffs.length) {
      return <div style={{ textAlign: 'center' }}>Тарифов нет</div>;
    }
    return (
      <div id="addTariff" className="basicForm">
        <Row type="flex" justify="space-between" gutter={16}>
          <Col span={18} />
          <Col span={6}>
            <div>
              <Button
                className="back-btn"
                type="primary"
                ghost
                htmlType="submit"
                onClick={() => prev()}
              >
                Назад
              </Button>
            </div>
          </Col>
        </Row>
        <Row type="flex" justify="space-between" gutter={16}>
          <div className="tariffs_row">
            {tariffs &&
            tariffs.map(tariff => (
              <React.Fragment key={tariff.tariffTypeKey}>
                <AddTariffForm
                  form={form}
                  handleTariff={this.handleTariff}
                  handleFeePeriod={this.props.handleFeePeriod}
                  tariff_prices={this.props.tariff_prices.prices}
                  getTariffPrice={this.props.getTariffPrice}
                  tariff={tariff}
                  tariffsPeriods={this.props.tariffsPeriods}
                  next={next}
                  defaultPrices={defaultPrices}
                />
              </React.Fragment>
            ))}
          </div>
        </Row>
      </div>
    );
  }
}

export default AddTariff;
